import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const LiveBroadcastCard = ({ broadcast, onJoin, onSave }) => {
  const formatListenerCount = (count) => {
    if (count >= 1000) {
      return `${(count / 1000)?.toFixed(1)}k`;
    }
    return count?.toString();
  };

  return (
    <div className="live-broadcast-card bg-card rounded-lg border border-border overflow-hidden hover:shadow-soft-lg transition-all duration-300">
      <div className="card-header relative">
        <div className="broadcast-artwork aspect-video relative overflow-hidden bg-muted">
          <Image 
            src={broadcast?.artwork}
            alt={broadcast?.artworkAlt}
            className="w-full h-full object-cover"
          />
          <div className="live-indicator absolute top-4 left-4 flex items-center gap-2 bg-error/90 backdrop-blur-sm px-3 py-1.5 rounded-full">
            <div className="w-2 h-2 bg-error-foreground rounded-full animate-pulse" />
            <span className="text-xs font-heading font-semibold text-error-foreground uppercase tracking-wide">
              В эфире
            </span>
          </div>
          <div className="listener-count absolute top-4 right-4 flex items-center gap-1.5 bg-background/80 backdrop-blur-sm px-3 py-1.5 rounded-full">
            <Icon name="Users" size={14} color="var(--color-foreground)" />
            <span className="text-xs font-mono text-foreground">
              {formatListenerCount(broadcast?.listenerCount)}
            </span>
          </div>
        </div>
      </div>
      <div className="card-body p-4">
        <div className="broadcast-info mb-3">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-1 line-clamp-2">
            {broadcast?.title}
          </h3>
          <div className="flex items-center gap-2 mb-2">
            <div className="host-avatar w-8 h-8 rounded-full overflow-hidden bg-muted flex-shrink-0">
              <Image 
                src={broadcast?.hostAvatar}
                alt={broadcast?.hostAvatarAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-sm text-muted-foreground truncate">
              {broadcast?.hostName}
            </span>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {broadcast?.description}
          </p>
        </div>

        <div className="broadcast-meta flex items-center gap-3 mb-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={14} color="currentColor" />
            <span className="font-mono">{broadcast?.duration}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Tag" size={14} color="currentColor" />
            <span>{broadcast?.category}</span>
          </div>
        </div>

        <div className="card-actions flex items-center gap-2">
          <button
            onClick={() => onJoin(broadcast)}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-200 active:scale-95"
          >
            <Icon name="Radio" size={18} color="currentColor" />
            <span className="font-heading font-medium">Присоединиться</span>
          </button>
          <button
            onClick={() => onSave(broadcast)}
            className="p-2.5 rounded-lg border border-border hover:bg-muted transition-colors duration-200"
            aria-label="Сохранить эфир"
          >
            <Icon name="Bookmark" size={18} color="var(--color-foreground)" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveBroadcastCard;